/**
 * BillingPeriodToggle — pílula de selecção de período de subscrição.
 * Usado no Site Comercial (Landing/Pricing) e na Área Cliente (Subscription).
 */
import { BILLING_PERIODS } from "@/lib/billing";
import { Badge } from "@/components/ui/badge";

export default function BillingPeriodToggle({
    value,
    onChange,
    variant = "light", // "light" para site público, "dark" para área cliente
    className = "",
    testId = "billing-period-toggle",
}) {
    const isDark = variant === "dark";
    return (
        <div
            className={`inline-flex flex-wrap items-center gap-1 rounded-full p-1 border ${
                isDark
                    ? "bg-secondary/40 border-border"
                    : "bg-card border-border"
            } ${className}`}
            data-testid={testId}
        >
            {BILLING_PERIODS.map((p) => {
                const active = value === p.id;
                return (
                    <button
                        key={p.id}
                        type="button"
                        onClick={() => onChange?.(p.id)}
                        className={`relative px-3 sm:px-4 py-1.5 rounded-full text-sm transition-colors ${
                            active
                                ? "bg-foreground text-background font-semibold"
                                : "text-muted-foreground hover:text-foreground"
                        }`}
                        data-testid={`${testId}-${p.id}`}
                        aria-pressed={active}
                    >
                        {p.short_label}
                        {p.discount_pct > 0 && (
                            <Badge
                                className={`ml-2 px-1.5 py-0 text-[10px] leading-tight border-none ${
                                    active
                                        ? "bg-[#2DD4BF]/20 text-[#0F766E]"
                                        : "bg-[#2DD4BF]/15 text-[#2DD4BF]"
                                }`}
                            >
                                -{p.discount_pct}%
                            </Badge>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
